import React, { useEffect } from 'react';
import { IconFont, useFocusIdx } from '@bay-email/editor';
import { RadioGroupField } from '../../../components/Form';
import { t } from '@bay-email/core';
import { useField } from 'react-final-form';

const options = [
	{
		value: 'none',
		label: t('None'),
	},
	{
		value: 'underline',
		label: <IconFont iconName='icon-underline' />,
	},
	{
		value: 'line-through',
		label: <IconFont iconName='icon-strikethrough' />,
	},
];

export function TextDecoration({ name }: { name?: string }) {
	const { focusIdx } = useFocusIdx();

	const fieldName = name || `${focusIdx}.attributes.text-decoration`;
	const { input } = useField<string | undefined>(fieldName, {
		subscription: {
			value: true,
		},
	});

	useEffect(() => {
		if ((input.value === undefined || input.value === '') && focusIdx) {
			input.onChange('none');
		}
	}, [focusIdx, input]);

	return (
		<RadioGroupField
			name={fieldName}
			options={options}
			type='button'
			formItem={{ style: { marginBottom: '8px' } }}
			labelHidden
		/>
	);
}
